module.exports = __webpack_public_path__ + "static/media/Fantastik.87f572f3.png";